import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import find from 'lodash/find';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import Label from 'zignal-landscape/lib/Label';
import Select from 'zignal-landscape/lib/Select';
import styles from './ProfileSelect.css';

class ProfileSelect extends React.Component {
  constructor(props) {
    super(props);
    this.handleCheckboxChanged = this.handleCheckboxChanged.bind(this);
  }

  handleCheckboxChanged(e) {
    // NOTE: Checkbox's `checked` state is handled independently of how many
    // profiles are actually selected because the box reflects if the <Select>
    // is editable or if the <Select> is not editable while auto-selecting all profiles.
    // In other words, the checkbox can NOT deselect all profiles.
    const { onChange, options, includeAllProfilesChanged } = this.props;
    const checked = e.currentTarget.checked;
    if (checked) {
      onChange(map(options, 'value'));
    }
    includeAllProfilesChanged(checked);
  }

  render() {
    const { options, value, onChange, includeAll } = this.props;
    const selectValue = map(value, (v) => find(options, {value: v}));

    return (
      <div className={styles.ProfileSelect}>
        <Checkbox
          value={options}
          name="selectAllProfiles"
          checked={includeAll}
          onChange={this.handleCheckboxChanged}
        />
        <Label inline htmlFor="selectAllProfiles">Include all</Label>

        {includeAll ?
          <p className={styles.profileList}>{map(options, 'label').join(', ')}</p> :
          <Select
            isMulti
            isClearable
            options={options}
            value={selectValue}
            onChange={(selectedOptions) => {
              onChange(map(selectedOptions, 'value'));
            }}
          />
        }
      </div>
    );
  }
}

ProfileSelect.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  includeAll: PropTypes.bool.isRequired,
  includeAllProfilesChanged: PropTypes.func.isRequired
};

export default ProfileSelect;
